<template>
  <ul :class="$style.list">
    <li
      v-for="(year, yearId) in yearsList"
      :key="yearId"
      :class="[[$style.year], { [$style.active]: year === activeYear }]"
      @click="$emit('change', year)"
    >
      {{ year }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'YearsList',

  model: {
    prop: 'activeYear',
    event: 'change',
  },

  props: {
    activeYear: {
      type: String,
      default: '',
    },

    yearsList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      initialYear: this.activeYear,
    }
  },
}
</script>

<style lang="scss" module>
.list {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
}

.year {
  padding: 8px 20px;
  border-radius: 24px;

  background-color: #fff4ee;
  cursor: pointer;

  transition-duration: 0.3s;

  transition-property: color, background-color;

  @include typo-headline;

  &:first-child {
    margin-left: 0;
  }

  &:hover {
    color: $gray-700;

    background-color: #fffbf2;
  }

  &.active {
    color: white;

    background-color: $bluko-500;

    &:hover {
      color: white;

      background-color: $bluko-300;
    }
  }
}
</style>
